import { render, staticRenderFns } from "./HotkeyHelpModal.vue?vue&type=template&id=204a397e&scoped=true"
import script from "./HotkeyHelpModal.vue?vue&type=script&lang=js"
export * from "./HotkeyHelpModal.vue?vue&type=script&lang=js"
import style0 from "./HotkeyHelpModal.vue?vue&type=style&index=0&id=204a397e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a397e",
  null
  
)

export default component.exports